import React, { useState } from "react";
import { message } from "antd";

import { userPost, userPut } from "../../../../../../libs/apis";
import { UserI } from "../../../../../../libs/interfaces";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";

const schemaReport = Yup.object({
  firstName: Yup.string()
    .min(3, "Nombres Requeridos")
    .max(50, "Nombres Requeridos")
    .required("Nombres Requeridos"),
  lastName: Yup.string()
    .min(3, "Apellidos Requeridos")
    .max(50, "Apellidos Requeridos")
    .required("Apellidos Requeridos"),
  user: Yup.string()
    .min(3, "El Usuario es requerido")
    .max(50, "El Usuario es requerido")
    .required("Usuario Requerido"),
  mail: Yup.string()
    .min(3, "El Email es requerido")
    .max(50, "El Email es requerido")
    .required("Email Requerido"),
  phone: Yup.string().required("Teléfono Requerido"),
  docNumber: Yup.string()
    .min(3, "Identificación Requerida")
    .max(15, "Identificación Requerida")
    .required("Identificación Requerida"),
  docTypeId: Yup.number().required("Tipo de Identificación Requerido"),
}).required();

const initialProducerValues: UserI = {
  uuid: "",
  client: "",
  clientId: null,
  user: "",
  password: "",
  fullName: "",
  firstName: "",
  lastName: "",
  mail: "",
  phone: "",
  profile: "",
  profileCode: "",
  profileId: null,
  typeId: null,
  type: "",
  areaId: null,
  area: "",
  positionId: null,
  position: "",
  docNumber: "",
  docType: "",
  docTypeId: null,
  createdAt: "",
  updatedAt: "",
  avatar: null,
};

interface HookPropsI {
  id: any;
  onClose: () => void;
  clientId: number;
}

export const useUserForm = ({ id, onClose, clientId }: HookPropsI) => {
  const [isProcessing, setProcessing] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
    reset,
    getValues,
  } = useForm<UserI | any>({
    resolver: yupResolver<Yup.AnyObject>(schemaReport),
    defaultValues: initialProducerValues,
  });

  const onSubmit = async () => {
    try {
      setProcessing(true);
      const values = getValues();
      values.clientId = clientId;

      if (id) {
        delete values.id;
        delete values.personId;
        delete values.fullName;
        delete values.type;
        delete values.area;
        delete values.position;
        delete values.profileCode;
        delete values.profile;
        delete values.docType;
        delete values.client;
        delete values.createdAt;
        delete values.updatedAt;

        const { data: dataUser } = await userPut(Number(id), values);
        message.success(dataUser);
      } else {
        const { data: dataUser } = await userPost(values);
        message.success(dataUser);
        onClose();
      }

      onClose();
    } catch (err: any) {
      message.error(err.toString());
    } finally {
      setProcessing(false);

    }
  };

  return {
    register,
    handleSubmit,
    errors,
    setValue,
    onSubmit,
    control,
    reset,
    getValues,
    isProcessing,
  };
};
